export default __webpack_public_path__ + "static/media/plate-of-fried-fish2.70d1f2bb.png";